import styled from 'styled-components';

export const StylesCalendar = styled.div`
    display: flex;
    align-self: flex-start;
    margin-bottom: 10px;
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 15px;
`;

export const SecondColumn = styled.div`
    display:flex;
    align-items:flex-end;

    @media (max-width: 960px) {
        width: 100%;
        
        & button {
            width: 100%;
        }
    }
`;
